import React from "react";
import AboutFirstSection from "../components/AboutUs/AboutFirstSection";
import TeamsSection from "../components/AboutUs/TeamsSection";
import OurteamsCards from "../components/AboutUs/OurteamsCards";

import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";
import ceo from "../assets/images/About/About-One.png";
import { Avatar, Box, Container, Grid, Typography } from "@mui/material";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import WhatSetAcross from "../components/Home/WhatSetAcross";
import BannerContent from "../components/BannerContent";
import teamImg from "../assets/images/About/IMG_1168 (1) (1).png";
import WorkingProcess from "../components/Home/WorkingProcess";

const AboutUs = () => {
  return (
    <>
      <BannerContent
        bannerImage={teamImg}
        title=""
        subtitle=""
        containerStyles={{ background: "none" }}
        bannerHeight="400px"
      />
      {/* <HeroSection
        bannerImage={banner1}
        heading="Trust. Compassion. Unyielding Protection."
        description="Across Assist is a vanguard of assurance, architecting transformative solutions that transcend convention. We engineer excellence, empowering industries and elevating client aspirations through innovation, integrity, and relentless pursuit of distinction"
        image={logo}
        gradientBg="linear-gradient(268.53deg, #ffd3b8 8.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      /> */}

      <Box sx={{ backgroundColor: "#ffffff", py: 4 }}>
        <h4 className="main-heading-font-size" style={{ textAlign: "center" }}>
          What sets Across Assist apart?
        </h4>
        <WhatSetAcross />
      </Box>
      {/* make new section start */}

      {/* AboutUs Animated Mission Section */}
      <section style={{ background: "#fff", padding: "2px 0" }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              background: "#fff",
              borderRadius: "18px",
              // boxShadow: "0 4px 16px 0 rgba(19,99,223,0.09)",
              p: { xs: 4, md: 6 },
              position: "relative",
              overflow: "hidden",
              textAlign: "center",
              // border: "1.5px solid #1377df17",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                color: "#1363DF",
                // mb: 3,
                fontSize: { xs: "2rem", md: "2.5rem" },
                lineHeight: 1.17,
                textShadow: "0 2px 8px #1363df0d",
              }}
            >
              We’re reshaping{" "}
              <span style={{ color: "#FFB544" }}>assurance</span> through
              innovation.
            </Typography>
            <Box
              sx={{
                zIndex: 1,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mb: 2,
                mt: 2,
              }}
            >
              {/* <Typography
                variant="body1"
                sx={{
                  color: "#303030",
                  fontSize: { xs: "1.09rem", md: "1.13rem" },
                  fontWeight: 400,
                  lineHeight: 1.7,
                  maxWidth: 810,
                  mx: "auto",
                }}
              >
                At Across Assist, we’re not just a company; we’re innovators,
                reshaping the assurance landscape. We’re committed to redefining
                what you can expect from assurance products—pushing the
                boundaries in every sector we touch. Each product is crafted
                with excellence to meet not just your needs, but also your
                aspirations.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#303030",
                  fontSize: { xs: "1.09rem", md: "1.13rem" },
                  fontWeight: 400,
                  lineHeight: 1.7,
                  maxWidth: 810,
                  mx: "auto",
                }}
              >
                Our passion is empowerment: not just solving problems, but
                creating opportunities. We help businesses thrive, drive
                financial growth, and enable truly memorable customer
                experiences.
              </Typography> */}
              <WorkingProcess />
            </Box>
            <Box
              sx={{
                my: { xs: 3, md: 5 },
                zIndex: 1,
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  fontSize: { xs: "2.5rem", md: "3.3rem" },
                  fontWeight: 800,
                  color: "#FFB544",
                  mx: 1,
                  lineHeight: 1,
                }}
              >
                “
              </Box>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: "1.09rem", md: "1.21rem" },
                  color: "#222", // softer black
                  maxWidth: 770,
                  px: 1.5,
                  position: "relative",
                  fontStyle: "italic",
                  fontFamily: "Gilroy,  sans-serif",
                  letterSpacing: 0.01,
                  lineHeight: 1.7,
                  textShadow: "0 1px 0 #fff",
                }}
              >
                What truly sets us apart is our people. By empowering our team
                to push boundaries, we don&#39;t just build better products—we
                build a better future for everyone.
              </Typography>
              <Box
                sx={{
                  fontSize: { xs: "2.5rem", md: "3.3rem" },
                  fontWeight: 800,
                  color: "#FFB544",
                  mx: 1,
                  lineHeight: 1,
                  transform: "scaleX(-1) translateY(-0.15em)",
                }}
              >
                “
              </Box>
            </Box>
          </Box>
        </Container>
      </section>

      {/* make new section end */}

      {/* <TeamsSection /> */}
      <section style={{ backgroundColor: "#fff6f1" }}>
        <h4 className="our-team text-[2.2rem] text-center">Our Team</h4>
        <div className="main-container-company-ceo alignment-center flex justify-center items-center w-full">
          <div className="max-w-screen-xl w-full flex justify-center items-center">
            <Box
              sx={{
                backgroundColor: "#fff6f1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Container
                maxWidth="lg"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    p: { xs: 2, md: 0 },
                    py: { xs: 2, md: 4 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: "99%",
                    // margin: "auto",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {/* Circular Image with ring */}
                    <Box
                      sx={{
                        mb: 1,
                        width: 200,
                        height: 200,
                        overflow: "hidden",
                        borderRadius: "50%",
                        position: "relative",
                        border: "4px solid transparent",
                        background:
                          "linear-gradient(93.14deg, #FF8C00, #FF4500)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 auto",
                      }}
                    >
                      <Avatar
                        alt="Neeraj Verma"
                        src={ceo}
                        sx={{ width: "100%", height: "100%" }}
                      />
                    </Box>

                    <Typography
                      variant="h5"
                      sx={{
                        fontFamily: '"Poppins", serif',
                        fontWeight: 600,
                        fontSize: {
                          xs: "1.15rem",
                          sm: "1.2rem",
                          md: "1.35rem",
                        },
                        textAlign: "center",
                      }}
                    >
                      Neeraj Verma
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        mt: -0.5,
                        fontFamily: '"Poppins", serif',
                        fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                        textAlign: "center",
                      }}
                    >
                      Co-Founder & CEO
                    </Typography>
                  </Grid>

                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {/* Bio */}
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: "center",
                        fontFamily: '"Poppins", serif',
                        mb: 1,
                        fontWeight: "500",
                        fontSize: {
                          xs: "0.82rem",
                          sm: "0.82rem",
                          md: "1.45rem",
                        },
                      }}
                    >
                      Mr. Neeraj Verma is the CEO and Director of Across Assist
                      Private Limited <i>(Formerly Bharti Assist Pvt. Ltd.)</i>.
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: "center",
                        fontFamily: '"Poppins", serif',
                        mb: 1,
                        fontSize: {
                          xs: "0.82rem",
                          sm: "0.82rem",
                          md: "1.3rem",
                        },
                      }}
                    >
                      Across Assist, a rapidly growing assurance services
                      company based in India. With over 20 years of experience
                      in the banking and financial services industry, he has
                      held pivotal roles at esteemed institutions such as ICICI
                      Bank, Fullerton India, Citi, and Cholamandalam.​ Under his
                      leadership, Across Assist has emerged as a leader in
                      delivering innovative, customer-centric assurance
                      solutions across sectors including travel, automotive,
                      electronics, and healthcare.
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: "center",
                        fontFamily: '"Poppins", serif',
                        fontSize: {
                          xs: "0.82rem",
                          sm: "0.82rem",
                          md: "1.3rem",
                        },
                      }}
                    >
                      The company boasts a global presence, serving over 200+
                      countries, and has achieved significant milestones such as
                      settling over $1 billion in claims and attaining a 4.6/5
                      customer satisfaction score. In recognition of his
                      contributions, Neeraj was honored as one of the "10 Best
                      CEOs in India 2024" by TradeFlock ,
                    </Typography>
                  </Grid>
                </Box>
              </Container>
            </Box>
          </div>
        </div>
      </section>



      <div className="max-w-full container text-center bg-[#fff6f1] pt-6 ">
        <div className="our-teamcontainer pt-5">
          {/* <h4 className="our-team text-[2.2rem]">Our Leadership</h4> */}

          <OurteamsCards />
        </div>
      </div>
    </>
  );
};

export default AboutUs;
